export function getAllColors() {
    return ["#A0CA2A", "#E97132", "#7317DE", "#6D6875", "#3A86FF"]
}